import * as React from 'react';
import { hydrate } from 'react-dom';
import { canUseDOM } from 'sletat-common-utils/lib/canUseDOM';
import { App } from '../../hotel-page';

if (canUseDOM) {
    // отлючение запоминания браузером текущего скролла(после обновления возвращает скролл в положение доперезагрузки)
    window.history.scrollRestoration = 'manual';
}

hydrate(<App />, document.getElementById('app-root'));
